
import Editor from "@/components/editor/editor.vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getLModelFileAdd,
  getLModelFileDetail,
  getOperList
} from "@/api/api-basic";

import uploadImage from "@/components/upload-image/upload-image.vue";
import showImg from "@/components/show-img/show-img.vue";
import { getOptionList, optionKey } from "@/api/api-dict";
import i18n from "@/config/i18n";
import {
  addAppUpdateInfo,
  invalidateUpgradeStatus
} from "@/api/api-app-update";
import { APP_TYPE_OPS } from "@/constants/constants";
import { LANGS } from "@/constants/constants";

@Component({
  components: {
    uploadImage,
    showImg,
    Editor
  }
})
export default class PiAddSystemNotice extends Vue {
  @Prop({ default: {} }) private ObjectData!: Record<string, any>;

  @Watch("ObjectData")
  getObjectData(val) {
    // 显示模态窗口
    if (val.openType === "copy" || val.openType === "edit") {
      this.modalShow = true;
      if (val.openType === "edit" && val.status >= 1) {
        this.isEditMode = true;
        this.modalTitle = i18n.t("appUpdate.editUpgradeReminder");
      } else {
        this.isEditMode = false;
        this.modalTitle = i18n.t("appUpdate.addUpgradeReminder");
      }
      // 通用方法来更新表单字段
      this.updateFormFields(val);
    }

    // 如果是复制操作，清空 pkId 字段
    if (val.openType === "copy") {
      this.formInline.pkId = "";
    }
  }

  private LANGS = LANGS;
  private isEditMode = false;
  private initialFormInlineState: objAny = {
    pkId: "",
    oprPkId: "",
    appType: "",
    remarks: "",
    forcedUpgradeVersion: "",
    remindUpgradeVersion: "",
    oprPkId: "",
    upgradeCopywritingThai: "",
    upgradeCopywritingEnglish: "",
    upgradeCopywritingChinese: ""
  };
  private formInline: objAny = { ...this.initialFormInlineState };

  private appTypeOps = APP_TYPE_OPS;
  private htmlContent = "";
  private upgradeTime = "";
  private loading = false;
  private modalShow = false;
  private modalTitle = i18n.t("appUpdate.addUpgradeReminder");
  private formObj: objAny = {};
  private ruleInline: objAny = {
    appType: [
      {
        required: true,
        message: i18n.t("appUpdate.rules.appType"),
        trigger: "blur"
      }
    ],
    oprPkIdList: [
      {
        required: true,
        message: i18n.t("appUpdate.rules.oprType"),
        trigger: "blur"
      }
    ],
    remindUpgradeVersion: [
      {
        required: true,
        message: i18n.t("appUpdate.rules.remindUpgradeVersion"),
        trigger: "blur"
      }
    ]
  };
  private fontBold1 = false;
  private fontBold2 = false;
  private fontBold3 = false;
  private isFocus = false;
  private isAdd = false;
  private PkId = "";
  private oprList = "";
  private langList: object[] = [];
  private fileTypeObjList: object[] = [];
  private businessTypeObjList: object[] = [];

  private resetFormInline() {
    this.formInline = { ...this.initialFormInlineState };
  }

  public async invalidate() {
    this.loading = true;
    const json = {
      pkId: this.ObjectData.oprPkId,
      status: this.ObjectData.status
    };
    const ret = await invalidateUpgradeStatus(json);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
    }
    this.loading = false;
    this.resetFormInline();
  }

  public open(item?: objAny) {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
    this.modalShow = true;
  }

  public add() {
    this.resetFormInline();
    this.modalShow = true;
  }

  public handleSubmit() {
    this.formObj = this.$refs["formInline"];
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }

  async submitData(): Promise<void> {
    this.loading = true;
    const obj = { ...this.formInline };
    const json: objAny = JSON.parse(JSON.stringify(obj));
    const ret = await addAppUpdateInfo(json);
    if (ret.status === this.$config.apiStatus) {
      if (this.isAdd) {
        this.$Message.success(i18n.t("operationSucess"));
      } else {
        this.$Message.success(i18n.t("operationSucess"));
      }
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
    this.resetFormInline();
  }

  public cancleHandle() {
    this.modalShow = false;
    this.isEditMode = false;
    this.modalTitle = i18n.t("appUpdate.addUpgradeReminder");
    this.resetFormInline();
  }

  async getLModelFileDetail(): Promise<void> {
    this.loading = true;
    const ret = await getLModelFileDetail({ PkId: this.PkId });
    if (ret.status === this.$config.apiStatus) {
      this.formInline.attachmentPkId = ret.data[0].attachmentPkId;
      this.formInline.businessType = ret.data[0].businessType + "";
      this.formInline.fileName = ret.data[0].fileName;
      this.formInline.fileType = ret.data[0].fileType + "";
      this.formInline.remarks = ret.data[0].remarks;
      this.formInline.templatePkId = ret.data[0].pkid;
    }
    this.loading = false;
  }

  // 新增方法用于更新表单字段
  updateFormFields(data) {
    // 遍历 initialFormInlineState 的 key，更新 formInline
    Object.keys(this.initialFormInlineState).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        this.formInline[key] = data[key] + "";
      }
    });
  }

  async getOptionList() {
    const ret = await getOptionList([
      optionKey.fileTypeObj,
      optionKey.businessTypeObj,
      optionKey.langObj
    ]); //请求字典
    this.fileTypeObjList = ret[optionKey.fileTypeObj]; //模板文件类型
    this.businessTypeObjList = ret[optionKey.businessTypeObj]; //模板文件业务类型
    this.langList = ret[optionKey.langObj];
  }

  async getOprs(): Promise<void> {
    const res = await getOperList();
    if (res && res.status == 0) {
      this.oprList = res.data;
    }
  }

  mounted() {
    //     fileTypeObj: "12427", //模板文件类型
    // businessTypeObj: "12428" //模板文件业务类型
    this.getOptionList();

    this.getOprs();
  }
}
